/**
 * 표준 URL(canonical/hreflang/사이트맵) 생성기 — **트레일링 슬래시로 통일**.
 *
 * 왜 필요한가:
 *   프리렌더 산출물이 `dist/<path>/index.html` 이라, 서버(NAS nginx)는 `/ac-datacenter` 요청을
 *   `/ac-datacenter/` 로 **301 리다이렉트**한다. 그런데 사이트맵과 canonical 은 슬래시 없는
 *   형태를 내보내고 있었다 → 검색엔진이 색인하려는 URL이 매번 301을 맞는다.
 *     · 크롤 예산 낭비(모든 페이지에서 왕복 1회 추가)
 *     · canonical 이 스스로 리다이렉트되는 URL을 가리켜 정규화 신호가 흐려짐
 *   페이지가 40개일 땐 미미했지만, 프로그래매틱 SEO로 수백~수천 장이 되면 치명적이다.
 *
 * 규칙: 경로는 항상 슬래시로 끝난다. 단 루트('/')와 파일(확장자 포함)은 예외.
 */
export const SITE_ORIGIN = 'https://heinrich.dasancms.co.kr'

/** '/ac-datacenter' → '/ac-datacenter/' (루트·파일은 그대로) */
export function normalizePath(path: string): string {
  if (!path) return '/'
  const [p, q = ''] = path.split('?')
  const query = q ? `?${q}` : ''
  if (p === '/') return `/${query}`
  // 확장자가 있으면 파일 — 슬래시를 붙이지 않는다(/sitemap.xml, /robots.txt)
  if (/\.[a-z0-9]{2,5}$/i.test(p)) return `${p}${query}`
  return `${p.replace(/\/+$/, '')}/${query}`
}

/** 절대 URL(canonical/hreflang용) */
export function absUrl(path: string): string {
  return `${SITE_ORIGIN}${normalizePath(path)}`
}

/**
 * 한 페이지의 canonical + hreflang 3종을 한 번에.
 * koPath 는 한국어 경로(예: '/ac-datacenter/t/fall'), enPath 는 없으면 '/en' 접두로 자동 유추.
 */
export function seoUrls(koPath: string, lang: 'ko' | 'en', enPath?: string) {
  const ko = absUrl(koPath)
  const en = absUrl(enPath ?? `/en${koPath}`)
  return {
    canonical: lang === 'en' ? en : ko,
    ko,
    en,
    xDefault: ko,   // 주 시장이 한국 — x-default 는 한국어
  }
}
